let TestCombatData = {
  type: "CombatData",
  Encounter: {
    n: "\n",
    t: "\t",
    title: "Encounter",
    duration: "06:42",
    DURATION: "402",
    damage: "41444887",
    "damage-m": "41.44",
    "damage-*": "41.44M",
    "DAMAGE-k": "41445",
    "DAMAGE-m": "41",
    "DAMAGE-b": "0",
    "DAMAGE-*": "41M",
    dps: "103096.73",
    "dps-*": "dps-*",
    DPS: "103097",
    "DPS-k": "103",
    "DPS-m": "DPS-m",
    "DPS-*": "103K",
    encdps: "103096.73",
    "encdps-*": "103.10K",
    ENCDPS: "103097",
    "ENCDPS-k": "103",
    "ENCDPS-m": "0",
    "ENCDPS-*": "103K",
    hits: "3089",
    crithits: "946",
    "crithit%": "0%",
    misses: "0",
    hitfailed: "4",
    swings: "3093",
    tohit: "99.80",
    TOHIT: "100",
    maxhit: "Limit Break-Chimatsuri-676054",
    MAXHIT: "Limit Break-676054",
    "maxhit-*": "Limit Break-Chimatsuri-676.05K",
    "MAXHIT-*": "Limit Break-676K",
    healed: "13660836",
    enchps: "33982.18",
    "enchps-*": "33.98K",
    ENCHPS: "33982",
    "ENCHPS-k": "34",
    "ENCHPS-m": "0",
    "ENCHPS-*": "33K",
    heals: "1439",
    critheals: "946",
    "critheal%": "0%",
    cures: "0",
    maxheal: "Terry Nazon-Essential Dignity-67782",
    MAXHEAL: "Terry Nazon-67782",
    maxhealward: "Terry Nazon-Essential Dignity-67782",
    MAXHEALWARD: "Terry Nazon-67782",
    "maxheal-*": "Terry Nazon-Essential Dignity-67.78K",
    "MAXHEAL-*": "Terry Nazon-67K",
    "maxhealward-*": "Terry Nazon-Essential Dignity-67.78K",
    "MAXHEALWARD-*": "Terry Nazon-67K",
    damagetaken: "10537009",
    "damagetaken-*": "10.54M",
    healstaken: "14157648",
    "healstaken-*": "14.16M",
    powerdrain: "0",
    "powerdrain-*": "0",
    powerheal: "104000",
    "powerheal-*": "104.00K",
    kills: "0",
    deaths: "3",
    CurrentZoneName: "Eden's Verse: Refulgence (Savage)",
    Last10DPS: "77318",
    Last30DPS: "89801",
    Last60DPS: "95323"
  },
  Combatant: {
    MissingNumber: {
      n: "\n",
      t: "\t",
      name: "MissingNumber",
      duration: "00:42",
      DURATION: "42",
      damage: "1551811",
      "damage-m": "1.55",
      "damage-b": "0.00",
      "damage-*": "1.55M",
      "DAMAGE-k": "1552",
      "DAMAGE-m": "2",
      "DAMAGE-b": "0",
      "DAMAGE-*": "1551K",
      "damage%": "38%",
      dps: "36947.88",
      "dps-*": "36.95K",
      DPS: "36948",
      "DPS-k": "37",
      "DPS-m": "0",
      "DPS-*": "36K",
      encdps: "29842.52",
      "encdps-*": "29.84K",
      ENCDPS: "29843",
      "ENCDPS-k": "30",
      "ENCDPS-m": "0",
      "ENCDPS-*": "29K",
      hits: "32",
      crithits: "0",
      "crithit%": "0%",
      crittypes: "-",
      misses: "0",
      hitfailed: "0",
      swings: "32",
      tohit: "100.00",
      TOHIT: "100",
      maxhit: "Heart Asunder-87973",
      MAXHIT: "87973",
      "maxhit-*": "Heart Asunder-87.97K",
      "MAXHIT-*": "87K",
      healed: "0",
      "healed%": "0%",
      enchps: "0.00",
      "enchps-*": "0",
      ENCHPS: "0",
      "ENCHPS-k": "0",
      "ENCHPS-m": "0",
      "ENCHPS-*": "0",
      critheals: "0",
      "critheal%": "0%",
      heals: "0",
      cures: "0",
      maxheal: "",
      MAXHEAL: "",
      maxhealward: "",
      MAXHEALWARD: "",
      "maxheal-*": "",
      "MAXHEAL-*": "",
      "maxhealward-*": "",
      "MAXHEALWARD-*": "",
      damagetaken: "0",
      "damagetaken-*": "0",
      healstaken: "0",
      "healstaken-*": "0",
      powerdrain: "0",
      "powerdrain-*": "0",
      powerheal: "0",
      "powerheal-*": "0",
      kills: "0",
      deaths: "0",
      threatstr: "+(0)0/-(0)0",
      threatdelta: "0",
      Last10DPS: "0",
      Last30DPS: "26561",
      Last60DPS: "36948",
      Job: "",
      ParryPct: "0%",
      BlockPct: "0%",
      IncToHit: "---",
      OverHealPct: "0%",
      DirectHitPct: "0%",
      DirectHitCount: "0",
      CritDirectHitCount: "0",
      CritDirectHitPct: "0%",
      overHeal: "0",
      damageShield: "0",
      absorbHeal: "0"
    },
    "Wyatt Earp": {
      n: "\n",
      t: "\t",
      name: "Wyatt Earp",
      duration: "06:42",
      DURATION: "402",
      damage: "8482600",
      "damage-m": "8.48",
      "damage-b": "0.01",
      "damage-*": "8.48M",
      "DAMAGE-k": "8483",
      "DAMAGE-m": "8",
      "DAMAGE-b": "0",
      "DAMAGE-*": "8482K",
      "damage%": "20%",
      dps: "21101.00",
      "dps-*": "21.10K",
      DPS: "21101",
      "DPS-k": "21",
      "DPS-m": "0",
      "DPS-*": "21K",
      encdps: "21101.00",
      "encdps-*": "21.10K",
      ENCDPS: "21101",
      "ENCDPS-k": "21",
      "ENCDPS-m": "0",
      "ENCDPS-*": "21K",
      hits: "495",
      crithits: "202",
      "crithit%": "41%",
      crittypes: "0.0%L - 0.0%F - 0.0%M",
      misses: "0",
      hitfailed: "0",
      swings: "495",
      tohit: "100.00",
      TOHIT: "100",
      maxhit: "Drill-86524",
      MAXHIT: "86524",
      "maxhit-*": "Drill-86.52K",
      "MAXHIT-*": "86K",
      healed: "24278",
      "healed%": "0%",
      enchps: "60.39",
      "enchps-*": "60",
      ENCHPS: "60",
      "ENCHPS-k": "0",
      "ENCHPS-m": "0",
      "ENCHPS-*": "60",
      critheals: "1",
      "critheal%": "100%",
      heals: "1",
      cures: "0",
      maxheal: "Second Wind-24278",
      MAXHEAL: "24278",
      maxhealward: "Second Wind-24278",
      MAXHEALWARD: "24278",
      "maxheal-*": "Second Wind-24.28K",
      "MAXHEAL-*": "24.28K",
      "maxhealward-*": "Second Wind-24.28K",
      "MAXHEALWARD-*": "24.28K",
      damagetaken: "793961",
      "damagetaken-*": "793.96K",
      healstaken: "1552367",
      "healstaken-*": "1.55M",
      powerdrain: "0",
      "powerdrain-*": "0",
      powerheal: "0",
      "powerheal-*": "0",
      kills: "0",
      deaths: "0",
      threatstr: "+(0)0/-(0)0",
      threatdelta: "0",
      Last10DPS: "14552",
      Last30DPS: "24999",
      Last60DPS: "19507",
      Job: "Mch",
      ParryPct: "0%",
      BlockPct: "0%",
      IncToHit: "72.73",
      OverHealPct: "0%",
      DirectHitPct: "37%",
      DirectHitCount: "183",
      CritDirectHitCount: "71",
      CritDirectHitPct: "14%",
      overHeal: "0",
      damageShield: "0",
      absorbHeal: "0"
    },
    "April O'Neil": {
      n: "\n",
      t: "\t",
      name: "April O'Neil",
      duration: "06:42",
      DURATION: "402",
      damage: "6959960",
      "damage-m": "6.96",
      "damage-b": "0.01",
      "damage-*": "6.96M",
      "DAMAGE-k": "6960",
      "DAMAGE-m": "7",
      "DAMAGE-b": "0",
      "DAMAGE-*": "6959K",
      "damage%": "16%",
      dps: "17313.33",
      "dps-*": "17.31K",
      DPS: "17313",
      "DPS-k": "17",
      "DPS-m": "0",
      "DPS-*": "17K",
      encdps: "17313.33",
      "encdps-*": "17.31K",
      ENCDPS: "17313",
      "ENCDPS-k": "17",
      "ENCDPS-m": "0",
      "ENCDPS-*": "17K",
      hits: "488",
      crithits: "141",
      "crithit%": "29%",
      crittypes: "0.0%L - 0.0%F - 0.0%M",
      misses: "0",
      hitfailed: "0",
      swings: "489",
      tohit: "100.00",
      TOHIT: "100",
      maxhit: "Hyosho Ranryu-113141",
      MAXHIT: "113141",
      "maxhit-*": "Hyosho Ranryu-113.14K",
      "MAXHIT-*": "113K",
      healed: "21277",
      "healed%": "0%",
      enchps: "52.80",
      "enchps-*": "52",
      ENCHPS: "53",
      "ENCHPS-k": "0",
      "ENCHPS-m": "0",
      "ENCHPS-*": "52",
      critheals: "0",
      "critheal%": "0%",
      heals: "12",
      cures: "0",
      maxheal: "Bloodbath-5599",
      MAXHEAL: "5599",
      maxhealward: "Bloodbath-5599",
      MAXHEALWARD: "5599",
      "maxheal-*": "Bloodbath-5.60K",
      "MAXHEAL-*": "5.60K",
      "maxhealward-*": "Bloodbath-5.60K",
      "MAXHEALWARD-*": "5.60K",
      damagetaken: "793236",
      "damagetaken-*": "793.24K",
      healstaken: "1598035",
      "healstaken-*": "1.60M",
      powerdrain: "0",
      "powerdrain-*": "0",
      powerheal: "0",
      "powerheal-*": "0",
      kills: "0",
      deaths: "0",
      threatstr: "+(0)0/-(0)0",
      threatdelta: "0",
      Last10DPS: "19324",
      Last30DPS: "22927",
      Last60DPS: "17804",
      Job: "Nin",
      ParryPct: "0%",
      BlockPct: "0%",
      IncToHit: "71.88",
      OverHealPct: "0%",
      DirectHitPct: "44%",
      DirectHitCount: "218",
      CritDirectHitCount: "61",
      CritDirectHitPct: "12%",
      overHeal: "0",
      damageShield: "0",
      absorbHeal: "21277"
    },
    "Nagini Riddle": {
      n: "\n",
      t: "\t",
      name: "Nagini Riddle",
      duration: "06:41",
      DURATION: "401",
      damage: "6142748",
      "damage-m": "6.14",
      "damage-b": "0.01",
      "damage-*": "6.14M",
      "DAMAGE-k": "6143",
      "DAMAGE-m": "6",
      "DAMAGE-b": "0",
      "DAMAGE-*": "6142K",
      "damage%": "14%",
      dps: "15318.57",
      "dps-*": "15.32K",
      DPS: "15319",
      "DPS-k": "15",
      "DPS-m": "0",
      "DPS-*": "15K",
      encdps: "15280.47",
      "encdps-*": "15.28K",
      ENCDPS: "15280",
      "ENCDPS-k": "15",
      "ENCDPS-m": "0",
      "ENCDPS-*": "15K",
      hits: "448",
      crithits: "137",
      "crithit%": "31%",
      crittypes: "0.0%L - 0.0%F - 0.0%M",
      misses: "0",
      hitfailed: "0",
      swings: "448",
      tohit: "100.00",
      TOHIT: "100",
      maxhit: "Full Thrust-83589",
      MAXHIT: "83589",
      "maxhit-*": "Full Thrust-83.59K",
      "MAXHIT-*": "83K",
      healed: "57117",
      "healed%": "0%",
      enchps: "142.08",
      "enchps-*": "142",
      ENCHPS: "142",
      "ENCHPS-k": "0",
      "ENCHPS-m": "0",
      "ENCHPS-*": "142",
      critheals: "0",
      "critheal%": "0%",
      heals: "7",
      cures: "0",
      maxheal: "Life Surge-14164",
      MAXHEAL: "14164",
      maxhealward: "Life Surge-14164",
      MAXHEALWARD: "14164",
      "maxheal-*": "Life Surge-14.16K",
      "MAXHEAL-*": "14.16K",
      "maxhealward-*": "Life Surge-14.16K",
      "MAXHEALWARD-*": "14.16K",
      damagetaken: "2064602",
      "damagetaken-*": "2.06M",
      healstaken: "1855847",
      "healstaken-*": "1.86M",
      powerdrain: "0",
      "powerdrain-*": "0",
      powerheal: "0",
      "powerheal-*": "0",
      kills: "0",
      deaths: "1",
      threatstr: "+(0)0/-(0)0",
      threatdelta: "0",
      Last10DPS: "31110",
      Last30DPS: "21680",
      Last60DPS: "19212",
      Job: "Vpr",
      ParryPct: "0%",
      BlockPct: "0%",
      IncToHit: "77.14",
      OverHealPct: "0%",
      DirectHitPct: "45%",
      DirectHitCount: "203",
      CritDirectHitCount: "65",
      CritDirectHitPct: "15%",
      overHeal: "0",
      damageShield: "0",
      absorbHeal: "57117"
    },
    "George Lass": {
      n: "\n",
      t: "\t",
      name: "George Lass",
      duration: "06:42",
      DURATION: "402",
      damage: "5352119",
      "damage-m": "5.35",
      "damage-b": "0.01",
      "damage-*": "5.35M",
      "DAMAGE-k": "5352",
      "DAMAGE-m": "5",
      "DAMAGE-b": "0",
      "DAMAGE-*": "5352K",
      "damage%": "12%",
      dps: "13313.73",
      "dps-*": "13.31K",
      DPS: "13314",
      "DPS-k": "13",
      "DPS-m": "0",
      "DPS-*": "13K",
      encdps: "13313.73",
      "encdps-*": "13.31K",
      ENCDPS: "13314",
      "ENCDPS-k": "13",
      "ENCDPS-m": "0",
      "ENCDPS-*": "13K",
      hits: "286",
      crithits: "85",
      "crithit%": "30%",
      crittypes: "0.0%L - 0.0%F - 0.0%M",
      misses: "0",
      hitfailed: "0",
      swings: "286",
      tohit: "100.00",
      TOHIT: "100",
      maxhit: "Quadruple Technical Finish-176880",
      MAXHIT: "176880",
      "maxhit-*": "Quadruple Technical Finish-176.88K",
      "MAXHIT-*": "176K",
      healed: "0",
      "healed%": "0%",
      enchps: "0.00",
      "enchps-*": "0",
      ENCHPS: "0",
      "ENCHPS-k": "0",
      "ENCHPS-m": "0",
      "ENCHPS-*": "0",
      critheals: "0",
      "critheal%": "0%",
      heals: "0",
      cures: "0",
      maxheal: "",
      MAXHEAL: "",
      maxhealward: "",
      MAXHEALWARD: "",
      "maxheal-*": "",
      "MAXHEAL-*": "",
      "maxhealward-*": "",
      "MAXHEALWARD-*": "",
      damagetaken: "841510",
      "damagetaken-*": "841.51K",
      healstaken: "1421758",
      "healstaken-*": "1.42M",
      powerdrain: "0",
      "powerdrain-*": "0",
      powerheal: "0",
      "powerheal-*": "0",
      kills: "0",
      deaths: "1",
      threatstr: "+(0)0/-(0)0",
      threatdelta: "0",
      Last10DPS: "6008",
      Last30DPS: "11035",
      Last60DPS: "9846",
      Job: "Rpr",
      ParryPct: "0%",
      BlockPct: "0%",
      IncToHit: "71.88",
      OverHealPct: "0%",
      DirectHitPct: "40%",
      DirectHitCount: "115",
      CritDirectHitCount: "37",
      CritDirectHitPct: "13%",
      overHeal: "0",
      damageShield: "0",
      absorbHeal: "0"
    },
    "Christopher Nolan": {
      n: "\n",
      t: "\t",
      name: "Christopher Nolan",
      duration: "06:42",
      DURATION: "402",
      damage: "4190368",
      "damage-m": "4.19",
      "damage-b": "0.00",
      "damage-*": "4.19M",
      "DAMAGE-k": "4190",
      "DAMAGE-m": "4",
      "DAMAGE-b": "0",
      "DAMAGE-*": "4190K",
      "damage%": "10%",
      dps: "10423.80",
      "dps-*": "10.42K",
      DPS: "10424",
      "DPS-k": "10",
      "DPS-m": "0",
      "DPS-*": "10K",
      encdps: "10423.80",
      "encdps-*": "10.42K",
      ENCDPS: "10424",
      "ENCDPS-k": "10",
      "ENCDPS-m": "0",
      "ENCDPS-*": "10K",
      hits: "393",
      crithits: "110",
      "crithit%": "28%",
      crittypes: "0.0%L - 0.0%F - 0.0%M",
      misses: "0",
      hitfailed: "0",
      swings: "393",
      tohit: "100.00",
      TOHIT: "100",
      maxhit: "Bloodspiller-39521",
      MAXHIT: "39521",
      "maxhit-*": "Bloodspiller-39.52K",
      "MAXHIT-*": "39K",
      healed: "538905",
      "healed%": "3%",
      enchps: "1340.56",
      "enchps-*": "1.34K",
      ENCHPS: "1341",
      "ENCHPS-k": "1",
      "ENCHPS-m": "0",
      "ENCHPS-*": "1340",
      critheals: "13",
      "critheal%": "28%",
      heals: "47",
      cures: "0",
      maxheal: "Blackest Night-43333",
      MAXHEAL: "43333",
      maxhealward: "Blackest Night-43333",
      MAXHEALWARD: "43333",
      "maxheal-*": "Blackest Night-43.33K",
      "MAXHEAL-*": "43.33K",
      "maxhealward-*": "Blackest Night-43.33K",
      "MAXHEALWARD-*": "43.33K",
      damagetaken: "1788069",
      "damagetaken-*": "1.79M",
      healstaken: "2364215",
      "healstaken-*": "2.36M",
      powerdrain: "0",
      "powerdrain-*": "0",
      powerheal: "48800",
      "powerheal-*": "48.80K",
      kills: "0",
      deaths: "0",
      threatstr: "+(0)0/-(0)0",
      threatdelta: "0",
      Last10DPS: "9456",
      Last30DPS: "13653",
      Last60DPS: "11304",
      Job: "Drk",
      ParryPct: "8%",
      BlockPct: "0%",
      IncToHit: "88.00",
      OverHealPct: "0%",
      DirectHitPct: "18%",
      DirectHitCount: "71",
      CritDirectHitCount: "18",
      CritDirectHitPct: "5%",
      overHeal: "0",
      damageShield: "129999",
      absorbHeal: "0"
    },
    "Ghost Crawler": {
      n: "\n",
      t: "\t",
      name: "Ghost Crawler",
      duration: "06:38",
      DURATION: "398",
      damage: "4038368",
      "damage-m": "4.04",
      "damage-b": "0.00",
      "damage-*": "4.04M",
      "DAMAGE-k": "4038",
      "DAMAGE-m": "4",
      "DAMAGE-b": "0",
      "DAMAGE-*": "4038K",
      "damage%": "9%",
      dps: "10146.65",
      "dps-*": "10.15K",
      DPS: "10147",
      "DPS-k": "10",
      "DPS-m": "0",
      "DPS-*": "10K",
      encdps: "10045.69",
      "encdps-*": "10.05K",
      ENCDPS: "10046",
      "ENCDPS-k": "10",
      "ENCDPS-m": "0",
      "ENCDPS-*": "10K",
      hits: "532",
      crithits: "142",
      "crithit%": "27%",
      crittypes: "0.0%L - 0.0%F - 0.0%M",
      misses: "0",
      hitfailed: "0",
      swings: "532",
      tohit: "100.00",
      TOHIT: "100",
      maxhit: "Confiteor-43798",
      MAXHIT: "43798",
      "maxhit-*": "Confiteor-43.80K",
      "MAXHIT-*": "43K",
      healed: "302976",
      "healed%": "2%",
      enchps: "753.67",
      "enchps-*": "753",
      ENCHPS: "754",
      "ENCHPS-k": "1",
      "ENCHPS-m": "0",
      "ENCHPS-*": "753",
      critheals: "0",
      "critheal%": "0%",
      heals: "18",
      cures: "0",
      maxheal: "Divine Veil-17594",
      MAXHEAL: "17594",
      maxhealward: "Divine Veil-17594",
      MAXHEALWARD: "17594",
      "maxheal-*": "Divine Veil-17.59K",
      "MAXHEAL-*": "17.59K",
      "maxhealward-*": "Divine Veil-17.59K",
      "MAXHEALWARD-*": "17.59K",
      damagetaken: "1632712",
      "damagetaken-*": "1.63M",
      healstaken: "2075145",
      "healstaken-*": "2.08M",
      powerdrain: "0",
      "powerdrain-*": "0",
      powerheal: "46700",
      "powerheal-*": "46.70K",
      kills: "0",
      deaths: "0",
      threatstr: "+(0)0/-(0)0",
      threatdelta: "0",
      Last10DPS: "5141",
      Last30DPS: "9268",
      Last60DPS: "9872",
      Job: "Pld",
      ParryPct: "10%",
      BlockPct: "47%",
      IncToHit: "87.50",
      OverHealPct: "0%",
      DirectHitPct: "20%",
      DirectHitCount: "105",
      CritDirectHitCount: "28",
      CritDirectHitPct: "5%",
      overHeal: "0",
      damageShield: "302976",
      absorbHeal: "0"
    },
    "Terry Nazon": {
      n: "\n",
      t: "\t",
      name: "Terry Nazon",
      duration: "06:41",
      DURATION: "401",
      damage: "2980824",
      "damage-m": "2.98",
      "damage-b": "0.00",
      "damage-*": "2.98M",
      "DAMAGE-k": "2981",
      "DAMAGE-m": "3",
      "DAMAGE-b": "0",
      "DAMAGE-*": "2980K",
      "damage%": "7%",
      dps: "7433.48",
      "dps-*": "7.43K",
      DPS: "7433",
      "DPS-k": "7",
      "DPS-m": "0",
      "DPS-*": "7433",
      encdps: "7414.99",
      "encdps-*": "7.41K",
      ENCDPS: "7415",
      "ENCDPS-k": "7",
      "ENCDPS-m": "0",
      "ENCDPS-*": "7414",
      hits: "233",
      crithits: "71",
      "crithit%": "30%",
      crittypes: "0.0%L - 0.0%F - 0.0%M",
      misses: "0",
      hitfailed: "1",
      swings: "234",
      tohit: "99.57",
      TOHIT: "100",
      maxhit: "Malefic IV-35177",
      MAXHIT: "35177",
      "maxhit-*": "Malefic IV-35.18K",
      "MAXHIT-*": "35K",
      healed: "5817950",
      "healed%": "42%",
      enchps: "14500.45",
      "enchps-*": "14.50K",
      ENCHPS: "14500",
      "ENCHPS-k": "15",
      "ENCHPS-m": "0",
      "ENCHPS-*": "14K",
      critheals: "142",
      "critheal%": "28%",
      heals: "505",
      cures: "0",
      maxheal: "Essential Dignity-67782",
      MAXHEAL: "67782",
      maxhealward: "Essential Dignity-67782",
      MAXHEALWARD: "67782",
      "maxheal-*": "Essential Dignity-67.78K",
      "MAXHEAL-*": "67.78K",
      "maxhealward-*": "Essential Dignity-67.78K",
      "MAXHEALWARD-*": "67.78K",
      damagetaken: "1879898",
      "damagetaken-*": "1.88M",
      healstaken: "1618352",
      "healstaken-*": "1.62M",
      powerdrain: "0",
      "powerdrain-*": "0",
      powerheal: "0",
      "powerheal-*": "0",
      kills: "0",
      deaths: "1",
      threatstr: "+(0)0/-(0)0",
      threatdelta: "0",
      Last10DPS: "6401",
      Last30DPS: "6625",
      Last60DPS: "8395",
      Job: "Sge",
      ParryPct: "0%",
      BlockPct: "0%",
      IncToHit: "73.68",
      OverHealPct: "32%",
      DirectHitPct: "7%",
      DirectHitCount: "17",
      CritDirectHitCount: "4",
      CritDirectHitPct: "2%",
      overHeal: "1832294",
      damageShield: "266974",
      absorbHeal: "0"
    },
    "Friedrich Nietzsche": {
      n: "\n",
      t: "\t",
      name: "Friedrich Nietzsche",
      duration: "06:42",
      DURATION: "402",
      damage: "2621846",
      "damage-m": "2.62",
      "damage-b": "0.00",
      "damage-*": "2.62M",
      "DAMAGE-k": "2622",
      "DAMAGE-m": "3",
      "DAMAGE-b": "0",
      "DAMAGE-*": "2621K",
      "damage%": "6%",
      dps: "6522.00",
      "dps-*": "6.52K",
      DPS: "6522",
      "DPS-k": "7",
      "DPS-m": "0",
      "DPS-*": "6522",
      encdps: "6522.00",
      "encdps-*": "6.52K",
      ENCDPS: "6522",
      "ENCDPS-k": "7",
      "ENCDPS-m": "0",
      "ENCDPS-*": "6522",
      hits: "213",
      crithits: "58",
      "crithit%": "27%",
      crittypes: "0.0%L - 0.0%F - 0.0%M",
      misses: "0",
      hitfailed: "3",
      swings: "216",
      tohit: "98.61",
      TOHIT: "99",
      maxhit: "Broil III-39695",
      MAXHIT: "39695",
      "maxhit-*": "Broil III-39.70K",
      "MAXHIT-*": "39K",
      healed: "6887102",
      "healed%": "50%",
      enchps: "17132.09",
      "enchps-*": "17.13K",
      ENCHPS: "17132",
      "ENCHPS-k": "17",
      "ENCHPS-m": "0",
      "ENCHPS-*": "17K",
      critheals: "145",
      "critheal%": "17%",
      heals: "849",
      cures: "0",
      maxheal: "Excogitation-66455",
      MAXHEAL: "66455",
      maxhealward: "Excogitation-66455",
      MAXHEALWARD: "66455",
      "maxheal-*": "Excogitation-66.46K",
      "MAXHEAL-*": "66.46K",
      "maxhealward-*": "Excogitation-66.46K",
      "MAXHEALWARD-*": "66.46K",
      damagetaken: "743021",
      "damagetaken-*": "743.02K",
      healstaken: "1667147",
      "healstaken-*": "1.67M",
      powerdrain: "0",
      "powerdrain-*": "0",
      powerheal: "8500",
      "powerheal-*": "8.50K",
      kills: "0",
      deaths: "0",
      threatstr: "+(0)0/-(0)0",
      threatdelta: "0",
      Last10DPS: "8924",
      Last30DPS: "6128",
      Last60DPS: "6338",
      Job: "Sch",
      ParryPct: "0%",
      BlockPct: "0%",
      IncToHit: "66.67",
      OverHealPct: "21%",
      DirectHitPct: "6%",
      DirectHitCount: "13",
      CritDirectHitCount: "2",
      CritDirectHitPct: "1%",
      overHeal: "1154613",
      damageShield: "1596897",
      absorbHeal: "0"
    },
    "John Doe": {
      n: "\n",
      t: "\t",
      name: "John Doe",
      duration: "00:47",
      DURATION: "47",
      damage: "189424",
      "damage-m": "0.19",
      "damage-b": "0.00",
      "damage-*": "189.42K",
      "DAMAGE-k": "189",
      "DAMAGE-m": "0",
      "DAMAGE-b": "0",
      "DAMAGE-*": "189K",
      "damage%": "4%",
      dps: "4030.30",
      "dps-*": "4.03K",
      DPS: "4030",
      "DPS-k": "4",
      "DPS-m": "0",
      "DPS-*": "4030",
      encdps: "3642.77",
      "encdps-*": "3.64K",
      ENCDPS: "3643",
      "ENCDPS-k": "4",
      "ENCDPS-m": "0",
      "ENCDPS-*": "3642",
      hits: "30",
      crithits: "0",
      "crithit%": "0%",
      crittypes: "-",
      misses: "0",
      hitfailed: "0",
      swings: "30",
      tohit: "100.00",
      TOHIT: "100",
      maxhit: "Shock Spikes-11548",
      MAXHIT: "11548",
      "maxhit-*": "Shock Spikes-11.55K",
      "MAXHIT-*": "11K",
      healed: "0",
      "healed%": "0%",
      enchps: "0.00",
      "enchps-*": "0",
      ENCHPS: "0",
      "ENCHPS-k": "0",
      "ENCHPS-m": "0",
      "ENCHPS-*": "0",
      critheals: "0",
      "critheal%": "0%",
      heals: "0",
      cures: "0",
      maxheal: "",
      MAXHEAL: "",
      maxhealward: "",
      MAXHEALWARD: "",
      "maxheal-*": "",
      "MAXHEAL-*": "",
      "maxhealward-*": "",
      "MAXHEALWARD-*": "",
      damagetaken: "700815",
      "damagetaken-*": "700.82K",
      healstaken: "0",
      "healstaken-*": "0",
      powerdrain: "0",
      "powerdrain-*": "0",
      powerheal: "0",
      "powerheal-*": "0",
      kills: "0",
      deaths: "6",
      threatstr: "+(0)0/-(0)0",
      threatdelta: "0",
      Last10DPS: "4373",
      Last30DPS: "2568",
      Last60DPS: "4030",
      Job: "",
      ParryPct: "0%",
      BlockPct: "0%",
      IncToHit: "100.00",
      OverHealPct: "0%",
      DirectHitPct: "0%",
      DirectHitCount: "0",
      CritDirectHitCount: "0",
      CritDirectHitPct: "0%",
      overHeal: "0",
      damageShield: "0",
      absorbHeal: "0"
    },
    "Limit Break": {
      n: "\n",
      t: "\t",
      name: "Limit Break",
      duration: "00:00",
      DURATION: "0",
      damage: "676054",
      "damage-m": "0.68",
      "damage-b": "0.00",
      "damage-*": "676.05K",
      "DAMAGE-k": "676",
      "DAMAGE-m": "1",
      "DAMAGE-b": "0",
      "DAMAGE-*": "676K",
      "damage%": "1%",
      dps: "∞",
      "dps-*": "---",
      DPS: "∞",
      "DPS-k": "∞",
      "DPS-m": "∞",
      "DPS-*": "---",
      encdps: "1681.73",
      "encdps-*": "1.68K",
      ENCDPS: "1682",
      "ENCDPS-k": "2",
      "ENCDPS-m": "0",
      "ENCDPS-*": "1681",
      hits: "1",
      crithits: "0",
      "crithit%": "0%",
      crittypes: "-",
      misses: "0",
      hitfailed: "0",
      swings: "1",
      tohit: "100.00",
      TOHIT: "100",
      maxhit: "Chimatsuri-676054",
      MAXHIT: "676054",
      "maxhit-*": "Chimatsuri-676.05K",
      "MAXHIT-*": "676K",
      healed: "0",
      "healed%": "0%",
      enchps: "0.00",
      "enchps-*": "0",
      ENCHPS: "0",
      "ENCHPS-k": "0",
      "ENCHPS-m": "0",
      "ENCHPS-*": "0",
      critheals: "0",
      "critheal%": "0%",
      heals: "0",
      cures: "0",
      maxheal: "",
      MAXHEAL: "",
      maxhealward: "",
      MAXHEALWARD: "",
      "maxheal-*": "",
      "MAXHEAL-*": "",
      "maxhealward-*": "",
      "MAXHEALWARD-*": "",
      damagetaken: "0",
      "damagetaken-*": "0",
      healstaken: "0",
      "healstaken-*": "0",
      powerdrain: "0",
      "powerdrain-*": "0",
      powerheal: "0",
      "powerheal-*": "0",
      kills: "0",
      deaths: "0",
      threatstr: "+(0)0/-(0)0",
      threatdelta: "0",
      Last10DPS: "---",
      Last30DPS: "---",
      Last60DPS: "---",
      Job: "",
      ParryPct: "0%",
      BlockPct: "0%",
      IncToHit: "---",
      OverHealPct: "0%",
      DirectHitPct: "0%",
      DirectHitCount: "0",
      CritDirectHitCount: "0",
      CritDirectHitPct: "0%",
      overHeal: "0",
      damageShield: "0",
      absorbHeal: "0"
    },
    "Selene (Friedrich Nietzsche)": {
      n: "\n",
      t: "\t",
      name: "Selene (Friedrich Nietzsche)",
      duration: "00:10",
      DURATION: "10",
      damage: "0",
      "damage-m": "0.00",
      "damage-b": "0.00",
      "damage-*": "0",
      "DAMAGE-k": "0",
      "DAMAGE-m": "0",
      "DAMAGE-b": "0",
      "DAMAGE-*": "0",
      "damage%": "0%",
      dps: "0.00",
      "dps-*": "0",
      DPS: "0",
      "DPS-k": "0",
      "DPS-m": "0",
      "DPS-*": "0",
      encdps: "0.00",
      "encdps-*": "0",
      ENCDPS: "0",
      "ENCDPS-k": "0",
      "ENCDPS-m": "0",
      "ENCDPS-*": "0",
      hits: "0",
      crithits: "0",
      "crithit%": "0%",
      crittypes: "0.0%L - 0.0%F - 0.0%M",
      misses: "0",
      hitfailed: "0",
      swings: "0",
      tohit: "---",
      TOHIT: "---",
      maxhit: "",
      MAXHIT: "",
      "maxhit-*": "",
      "MAXHIT-*": "",
      healed: "1984",
      "healed%": "100%",
      enchps: "220.44",
      "enchps-*": "220",
      ENCHPS: "220",
      "ENCHPS-k": "0",
      "ENCHPS-m": "0",
      "ENCHPS-*": "220",
      critheals: "2",
      "critheal%": "67%",
      heals: "3",
      cures: "0",
      maxheal: "Whispering Dawn (*)-662",
      MAXHEAL: "662",
      maxhealward: "Whispering Dawn (*)-662",
      MAXHEALWARD: "662",
      "maxheal-*": "Whispering Dawn (*)-662",
      "MAXHEAL-*": "662",
      "maxhealward-*": "Whispering Dawn (*)-662",
      "MAXHEALWARD-*": "662",
      damagetaken: "0",
      "damagetaken-*": "0",
      healstaken: "0",
      "healstaken-*": "0",
      powerdrain: "0",
      "powerdrain-*": "0",
      powerheal: "0",
      "powerheal-*": "0",
      kills: "0",
      deaths: "0",
      threatstr: "+(0)0/-(0)0",
      threatdelta: "0",
      Last10DPS: "",
      Last30DPS: "",
      Last60DPS: "",
      Job: "",
      ParryPct: "0%",
      BlockPct: "0%",
      IncToHit: "---",
      OverHealPct: "100%",
      DirectHitPct: "0%",
      DirectHitCount: "0",
      CritDirectHitCount: "0",
      CritDirectHitPct: "0%",
      overHeal: "1984",
      damageShield: "0",
      absorbHeal: "0"
    }
  },
  isActive: "true"
};

export default TestCombatData;
